<ng-container *ngIf="statusPageStore.status$ | async as status">
  <div *ngIf="status !== statusPageType.Operational" data-at-head class="head">
    <div data-at-status-page class="flex flex-row">
      <div class="icon flex flex-row justify-center items-center">
        <mat-icon>info</mat-icon>
      </div>
      <div
        data-at-headline
        class="headline flex flex-col gt-sm:flex-row justify-between items-center"
      >
        <ng-container *ngIf="status === statusPageType.Under_Maintenance">
          {{ 'GENERAL.STATUSPAGE.MAINTENANCE_MESSAGE' | translate }}
        </ng-container>
        <ng-container
          *ngIf="
            status === StatusPageStatus.Major_Outage ||
            status === StatusPageStatus.Partial_Outage ||
            status === StatusPageStatus.Degraded_Performance
          "
        >
          {{ 'GENERAL.STATUSPAGE.ERROR_MESSAGE' | translate }}
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngFor="let maintenance of statusPageStore.scheduledMaintenance$ | async">
  <div data-at-head class="head" *ngIf="maintenance && isReminderDate(maintenance.scheduled_for)">
    <div data-at-upcoming-maintenance class="flex flex-row">
      <div class="icon flex flex-row justify-center items-center">
        <mat-icon>info</mat-icon>
      </div>
      <div
        data-at-headline
        class="headline flex flex-col gt-sm:flex-row justify-between items-center"
      >
        {{
          'GENERAL.STATUSPAGE.UPCOMING_MAINTENANCE_MESSAGE'
            | translate
              : {
                  scheduledFrom: maintenance.scheduled_for | date: 'short',
                  scheduledUntil: maintenance.scheduled_until | date: 'short'
                }
        }}
      </div>
    </div>
  </div>
</ng-container>
